export enum ReleaseRouteFormFields {
  RouteStartTime = 'routeStartTime',
  DoorNumber = 'doorNumber',
  TrailerNumber = 'trailerNumber',
  DockLocation = 'dockLocation',
  NearestDoor = 'nearestDoor',
}
